export enum GridMessages {
  DeletedItemsTips = 'XiUh',
  ShowingEntities = '4KTO',
  ShowingEntitiesWithSelected = 'z9fN',
  EntityTitles = 'l2Bg',
  Items = 'vQ/7',
  EventsBrackets = 'c5jz',
}
